import { IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'

export const SquareIconButton = styled(IconButton)(() => ({
  borderRadius: 0,
  '&.MuiButtonBase-root:hover': {
    backgroundColor: 'transparent'
  }
}))
